(function($) {
    $(document).ready(function() {
        var otPanel = $('.page-otzyvy__panel-body--right');

        $(otPanel).each(function(){
            var reviewFull = $(this).html();
            var review = reviewFull;
            var revDl = 600;

            if( review.length > revDl )
            {
                review = review.substring(0, revDl);
                $(this).html( review + '...' + '<div class="page-otzyvy__panel-readmore">Читать полностью &rarr;</div>' );
            }
            $(this).append('<div class="page-otzyvy__panel-full_text" style="display: none;">' + reviewFull + '</div>');
        });

        $(".page-otzyvy__panel-readmore").click(function(){
            $(this).parent().html( $(this).parent().find(".page-otzyvy__panel-full_text").html() );
        });

    });

})(jQuery);
